import { Box, styled } from '@mui/material';
import { BoxProps } from '@mui/system/Box';
import { COLOR_ACCENT } from 'shared/config';

const StyledBox = styled(Box)(({ theme }) => ({
  '--width': '8px',
  aspectRatio: 1,
  borderRadius: '50%',
  background: `
    radial-gradient(farthest-side, ${COLOR_ACCENT} 94%, transparent) top/var(--width) var(--width) no-repeat,
    conic-gradient(transparent 5%, ${COLOR_ACCENT} 60%)
  `,
  mask: 'radial-gradient(farthest-side, transparent 75%, black 0)',
  WebkitMask: 'radial-gradient(farthest-side, transparent 75%, black 0)',
  animation: 's3 0.8s infinite linear',
  transformOrigin: 'center center',
  maskImage: 'radial-gradient(farthest-side, transparent 75%, black 0)',
  maskMode: 'alpha',
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  WebkitMaskImage: 'radial-gradient(farthest-side, transparent 75%, black 0)',
  WebkitMaskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  '@keyframes s3': {
    to: {
      transform: 'rotate(1turn)',
    },
  },
}));

type SpinnerProps = {
  size?: number;
} & BoxProps;

export const Spinner = ({ size = 100, ...props }: SpinnerProps) => {
  return <StyledBox width={size} {...props} />;
};
